import DocumentConfiguration, {
    CONFIG_GROUP,
    CONFIG_OPTION,
    DEFAULT_CONFIG_GROUPS,
    DEFAULT_CONFIGS,
} from '../../../document/pages/Configuration';
import * as _documentQueries from '../queries.ts';
import { GET_OVERVIEW_DATA, UPDATE_FIELDS_CONFIG } from '../queries.ts';
import { CHANNEL_CONFIG_PATH, CHANNEL_PATH, OVERVIEW_PATH } from '../constants.ts';
import { DocumentType } from '../../../document/constants.ts';
import { cloneDeep } from 'lodash';
import UniversalFieldsConfig from '../components/UniversalFieldsConfig.tsx';
import { convertFieldsToEnabledFieldInputs } from '../../../document/components/fieldsConfigData.ts';
import { UniversalDocumentConfig } from '../components/UniversalDocumentConfig.tsx';

const configOptions = {
    [CONFIG_OPTION.General]: DEFAULT_CONFIGS[CONFIG_OPTION.General],
    [CONFIG_OPTION.Fields]: UniversalFieldsConfig,
    [CONFIG_OPTION.Email]: DEFAULT_CONFIGS[CONFIG_OPTION.Email],
    [CONFIG_OPTION.MasterData]: DEFAULT_CONFIGS[CONFIG_OPTION.MasterData],
    [CONFIG_OPTION.CustomizationParams]: DEFAULT_CONFIGS[CONFIG_OPTION.CustomizationParams],
    [CONFIG_OPTION.SFTP]: DEFAULT_CONFIGS[CONFIG_OPTION.SFTP],
    [CONFIG_OPTION.Document]: ({ channel, handlers }) => {
        const fieldInputs = convertFieldsToEnabledFieldInputs(channel?.documentConfig?.fields);
        return (
            <UniversalDocumentConfig
                config={channel?.documentConfig}
                onSubmit={(formData) =>
                    handlers.onUpdateDocumentConfig({ documentConfig: formData, fieldConfigs: fieldInputs })
                }
            />
        );
    },
    [CONFIG_OPTION.AS2]: DEFAULT_CONFIGS[CONFIG_OPTION.AS2],
    [CONFIG_OPTION.Upload]: DEFAULT_CONFIGS[CONFIG_OPTION.Upload],
    [CONFIG_OPTION.Discard]: DEFAULT_CONFIGS[CONFIG_OPTION.Discard],
};

const configGroups = cloneDeep(DEFAULT_CONFIG_GROUPS);
configGroups[CONFIG_GROUP.Processing] = [
    CONFIG_OPTION.Document,
    CONFIG_OPTION.Fields,
    CONFIG_OPTION.CustomizationParams,
    CONFIG_OPTION.MasterData,
    CONFIG_OPTION.Discard,
];

const documentConfiguration = {
    service: 'universal',
    documentType: DocumentType.Universal,
    documentTypeName: 'universal',
    activeTab: 'universal',
    documentQueries: _documentQueries,
    getOverviewData: GET_OVERVIEW_DATA,
    updateMutation: UPDATE_FIELDS_CONFIG,
    channelPath: CHANNEL_PATH,
    overviewPath: OVERVIEW_PATH,
    configPath: CHANNEL_CONFIG_PATH,
    configOptions,
    configGroups,
};

const Configuration = (props) => <DocumentConfiguration documentConfiguration={documentConfiguration} {...props} />;

export default Configuration;
